import { type ComponentPropsWithoutRef, forwardRef, memo, useEffect, useState } from 'react';
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';
import { useCombinedRefs, useResizeObserver } from '@toss/react';
import { useAnimate } from 'framer-motion';
import { cn } from '@/utils/tailwind.util';

// 브라우저에 ResizeObserver가 없을 경우에만 polyfill 적용
// _apps로 올릴지 고민
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserverPolyfill;
}
export const HeightAnimate = memo(forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({
  children,
  className,
  ...rest
}, ref) => {
  const [height, setHeight] = useState<number | 'auto'>('auto');
  const [scope, animate] = useAnimate();

  // ResizeObserver를 사용하여 높이를 계산.
  // 부모가 display:none이 되는 순간 contentRect.height === 0 보고가 들어오는데,
  // 이걸 그대로 저장하면 다시 display:block으로 돌아올 때 0 → 실제 높이로
  // 0.1s 애니메이션이 실행되어 카드들이 겹쳐 보였다가 아래로 펴지는 현상이 발생한다.
  // 0 보고는 무시하고 마지막으로 측정된 실제 높이를 유지한다.
  const resizeObserverRef = useResizeObserver(entry => {
    if (entry.contentRect.height === 0) return;
    setHeight(entry.contentRect.height);
  });
  const combinedRef = useCombinedRefs<HTMLDivElement>(scope, ref);
  useEffect(() => {
    animate(scope.current, {
      height
    }, {
      duration: 0.1
    });
  }, [height, animate, scope]);
  return <div ref={combinedRef} className="w-full" {...rest}>
          <div className={cn('w-full flex-col', className)} ref={resizeObserverRef}>
            {children}
          </div>
        </div>;
}));